











import Vue from "vue";
import CustomTable from "@/components/Table/table.vue";
import { DataTableHeader } from "vuetify/types";
import { store } from "@/store/store";
import { Log } from "@/store/modules/Log/interface";
import Utils from "@/utils/utils";

interface DeviceTableData {
  headers: Array<DataTableHeader>;
  items_displayed: Array<string>;
}

export default Vue.extend({
  name: "LogsTable",
  components: { CustomTable },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayDescriptionPanel: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false
    }
  },
  data: (): DeviceTableData => {
    return {
      headers: [
        { text: "Type", value: "controller_type", align: "start", sortable: false },
        { text: "Commande", align: "start", value: "type", sortable: false },
        { text: "Utilisateur", align: "start", value: "user", sortable: false },
        { text: "Agence", value: "agence", sortable: false },
        { text: "message", value: "message", sortable: false },
        { text: "Date", value: "date" }
      ],
      items_displayed: []
    };
  },
  methods: {
    format_data(): Array<Log> {
      const logs = store.getters.LOG_ALL_ID;
      return logs.map((log_id) => {
        const log = { ...store.getters.LOG_BY_ID[log_id] };
        log.agence = store.getters.AGENCE_BY_ID[log.agence].name;
        log.date = Utils.transformDateToYMDHMS(log.date);
        return log;
      });
    }
  }
});
